import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { FmIcon, FmNutrientsWideTable, FmRadioButton, FmReleaseChart, FmUnderlineNav, FmLoader, FmAllModals, FmBlackPopup } from "../../../Components";
import { useIsMobile, useTheme } from "../../../Hooks";
import { GeneralState, SolutionState, AgriSolutionState } from "../../../Redux";
import { ONE, ZERO } from "../../../Utils/Consts";
import { getMonthFromNumber } from "../../../Utils/TimeUtils";

import useStyles from "./StepTwoPage.style";
import { getCurrentMonthName, createMulticotePdf } from "../../PageReleaseChart/Utils";
import { SavedItemsState } from "../../../Redux/States";
import { shareableItemTypes } from "../../../Utils/Enums";
import { LOGGED_IN_ROUTES } from "../../../Constants";

const StepTwoPage = () => {
    const [graphType, setGraphType] = useState<string>("Line");

    const classes = useStyles();
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const theme = useTheme();
    const history = useHistory();
    const dispatch = useDispatch();
    const sharedItemId = useSelector(GeneralState.Selectors.selectSharedItemId);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [ShowBlackSnackbar, setShowBlackSnackbar] = useState<boolean>(false);
    const releaseGraphData = useSelector(SolutionState.Selectors.selectReleaseGraphState);
    const radioButtonArray = [t("multicoteSolutionPage.line"), t("multicoteSolutionPage.bar")];

    const handleGraphType = (e: any) => {
        setGraphType(e.target.value);
    };
    const savedItemId = useSelector(SolutionState.Selectors.selectItemId);

    const isUserNavigateToMainPage = useSelector(GeneralState.Selectors.selectUserNavigateToMainPage);
    const selectedBlendObject = useSelector(SolutionState.Selectors.selectBlendObject);
    const isUserSave = useSelector(SolutionState.Selectors.selectIsUserSave);
    const [showSaveItemModal, setShowSaveItemModal] = useState<boolean>(false);
    const user = useSelector(GeneralState.Selectors.selectUser);
    useEffect(() => {
        if (sharedItemId && sharedItemId !== 0) {
            dispatch(GeneralState.Actions.setUserNeedToViewSharableItem(false));
            dispatch(SavedItemsState.Thunks.getSavedItemById(sharedItemId ? sharedItemId : 0));
        }
    }, [isUserNavigateToMainPage]);

    useEffect(() => {
        (window as any).dataLayer.push({
            event: "MulticoteResultsStage",
            pageUrl: "https://multimatch.haifa-group.com/multi-match/solution/result",
            pageTitle: "MulticoteResultsStage",
        });
    }, []);

    const generatePdf = () => {
        const data = {
            name: user?.name,
            phoneNumber: "",
            date: new Date().toLocaleDateString(),
            time: new Date().toLocaleTimeString("en-US", {
                hour12: false,
                hour: "numeric",
                minute: "numeric",
            }),
            bestSolutionFormula: selectedBlendObject ? selectedBlendObject.name : "",
        };

        setShowLoader(true);
        createMulticotePdf(theme.images.pdfLogo, theme.images.pdfFooter, data);
        setShowLoader(false);
    };

    const handleClickOnShare = async () => {
        if (savedItemId && savedItemId != 0) {
            await dispatch(SolutionState.Actions.setIsUserShare(true));
            await dispatch(AgriSolutionState.Thunks.share(savedItemId ? savedItemId : 0, shareableItemTypes.multicote));
            await dispatch(SolutionState.Actions.setIsUserShare(false));
            dispatch(GeneralState.Actions.setSharedSavedItemId(0));
        }
    };

    const openMailBoxToShareItem = () => {
        if (savedItemId && savedItemId != 0) {
            const link = escape(releaseGraphData.shareLink);
            const name = selectedBlendObject && selectedBlendObject.name ? selectedBlendObject.name : "";
            const body = `${t("ShareEmail.body.please")}%20${t("ShareEmail.body.find")}%20${t("ShareEmail.body.attached")}%20%0D%0A${link} %20${t(
                "ShareEmail.body.recommendation"
            )}%0D%0A${t("ShareEmail.body.Thank")}%20${t("ShareEmail.body.you")}%20${t("ShareEmail.body.Haifa")}%20${t("ShareEmail.body.Group")}`;

            window.open(`mailto:?subject=${t("ShareEmail.title")}%20'${name}'&body=` + body);
        } else {
            window.alert(`${t("PageReleaseChart.shareUnsavedItem")}`);
        }
    };

    useEffect(() => {
        if (releaseGraphData.isUserShare && releaseGraphData.shareLink) {
            openMailBoxToShareItem();
        }
    }, [releaseGraphData]);

    const { activeMetricMethod } = useSelector(GeneralState.Selectors.selectMetricMethods);
    const valueSelected = activeMetricMethod === "1" ? ZERO : ONE;

    const firstMonth = releaseGraphData.releaseGraphValues && releaseGraphData.releaseGraphValues[0] && releaseGraphData.releaseGraphValues[0].month;
    const data = releaseGraphData && releaseGraphData.releaseGraphValues ? releaseGraphData.releaseGraphValues : [];
    const graphData = data.map((month) => {
        return {
            name: getMonthFromNumber(((firstMonth as number) + month.index) % 12),
            N: month.nutrient[0].releaseValues[valueSelected].value,
            P: month.nutrient[1].releaseValues[valueSelected].value,
            K: month.nutrient[2].releaseValues[valueSelected].value,
            tooltip: {
                N: month.nutrient[0].releaseValues[valueSelected].remainValue,
                P: month.nutrient[1].releaseValues[valueSelected].remainValue,
                K: month.nutrient[2].releaseValues[valueSelected].remainValue,
            },
        };
    });

    const currentReleaseValues =
        releaseGraphData.currentDayReleaseRemainValuesForMulticoteSolution.length > 0
            ? releaseGraphData.currentDayReleaseRemainValuesForMulticoteSolution[valueSelected]
            : null;
    const currentReleaseString = currentReleaseValues
        ? `${getCurrentMonthName()}: ${t("PageReleaseChart.currentDayRemainingReleaseValues.postValue")}${t(
              "PageReleaseChart.currentDayRemainingReleaseValues.Percentage"
          )}:  ${currentReleaseValues.n}, ${currentReleaseValues.p}, ${currentReleaseValues.k}%`
        : "";
    //------------ Modals ---------------------//
    const closeSaveItemModalHandle = () => {
        setShowSaveItemModal(false);
    };
    const openSaveItemModalHandle = () => {
        setShowSaveItemModal(true);
    };
    //-----------------------------------------//
    const saveSolutionHandler = async () => {
        await dispatch(SolutionState.Actions.setIsUserSave(true));
        await dispatch(SolutionState.Thunks.saveProcess());

        if (isUserSave) {
            setShowBlackSnackbar(true);
        }
    };
    const closeSnackbarHandler = () => {
        setShowBlackSnackbar(false);
    };
    const onPressNavigateBack = () => {
        dispatch(SolutionState.Actions.setUserEditAfterGettingResult(true));
        history.push(LOGGED_IN_ROUTES.SOLUTION_FIRST_STEP);
    };
    return (
        <div className={isMobile ? classes.mobile_stepTwo_container : classes.stepTwo_container}>
            {ShowBlackSnackbar && (
                <div className={classes.snackbar_container}>
                    <FmBlackPopup text={t("saveItemPopup.snackbar")} snackbar={true} onClose={closeSnackbarHandler} />
                </div>
            )}
            <div className={isMobile ? classes.mobile_title_container : classes.title_container}>
                <span>{selectedBlendObject ? selectedBlendObject.name : t("multicoteSolutionPage.title")}</span>
                {!isMobile ? (
                    <div className={classes.underlineNav_container}>
                        <FmUnderlineNav title={t("multicoteSolutionPage.changeCalculationSetting")} onClick={onPressNavigateBack} />
                    </div>
                ) : (
                    <div>
                        <FmIcon url={theme.images.share} onClick={handleClickOnShare} />
                    </div>
                )}
            </div>
            <div className={isMobile ? classes.mobile_secondRow : classes.secondRow}>
                <div>
                    <FmRadioButton
                        onChange={(e: any) => handleGraphType(e)}
                        values={radioButtonArray}
                        title={t("PageReleaseChart.greenMessage.radioButtonLabel")}
                    />
                </div>
                <span className={classes.currentPercentage}>{currentReleaseString}</span>
                {!isMobile && (
                    <div className={classes.links}>
                        {!showLoader ? (
                            <FmUnderlineNav title={t("PageReleaseChart.buttons.downloadFile")} onClick={generatePdf} />
                        ) : (
                            <FmLoader size={"verySmall"} />
                        )}
                        <FmUnderlineNav
                            title={isMobile ? t("PageReleaseChart.buttons.shareLink.mobile") : t("PageReleaseChart.buttons.shareLink.desktop")}
                            onClick={handleClickOnShare}
                        />
                        <FmUnderlineNav
                            title={t("multicoteSolutionPage.save")}
                            onClick={!isUserSave ? openSaveItemModalHandle : saveSolutionHandler}
                            disabled={false}
                        />
                    </div>
                )}
            </div>
            <div className={isMobile ? classes.mobile_graph_container : classes.graph_container}>
                <FmReleaseChart id={"divToPrint"} graphData={graphData} graphType={graphType} />
            </div>
            <div className={classes.wideTable_container}>
                <FmNutrientsWideTable title={t("multicoteSolutionPage.graphCodCodTitle")} tableData={graphData} />
            </div>
            <FmAllModals saveItemModalIsOpen={showSaveItemModal} saveItemModalOnClose={closeSaveItemModalHandle} saveItemModalAction={saveSolutionHandler} />
        </div>
    );
};

export default StepTwoPage;
